import React from 'react';
import styles from '../../styles/HomePage.module.scss';

const CarouselNavArrow = ({ direction, onClick }) => (
  <button
    type="button"
    className={`${styles.carouselArrow} ${direction === 'prev' ? styles.carouselArrowPrev : styles.carouselArrowNext}`}
    onClick={onClick}
    aria-label={direction === 'prev' ? 'Попередній слайд' : 'Наступний слайд'}
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
      {direction === 'prev' ? (
        <path d="M15 6l-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />
      ) : (
        <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
      )}
    </svg>
  </button>
);

const CarouselNav = ({ total, current, onPrev, onNext, onDotClick, className = '' }) => (
  <div className={`${styles.posterDotsBar}${className ? ` ${className}` : ''}`}>
    <CarouselNavArrow direction="prev" onClick={onPrev} />
    <ul className={styles.posterDotsList}>
      {Array.from({ length: total }, (_, index) => (
        <li key={index} className={index === current ? styles.posterDotsActive : undefined}>
          <button
            type="button"
            aria-label={`Слайд ${index + 1}`}
            onClick={() => onDotClick(index)}
          />
        </li>
      ))}
    </ul>
    <CarouselNavArrow direction="next" onClick={onNext} />
  </div>
);

export default CarouselNav;
